import React, { useEffect, useState } from 'react';
export function ScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const progress = scrolled / scrollHeight * 100;
      setScrollProgress(progress);
    };
    window.addEventListener('scroll', updateScrollProgress);
    updateScrollProgress(); // Initial calculation
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-zinc-900" data-id="element-2223">
      <div className="h-full bg-gradient-to-r from-[#3ab795] to-[#2da07d] transition-all duration-150 ease-out" style={{
      width: `${scrollProgress}%`
    }} data-id="element-2224" />
    </div>;
}